import './style.css';
import api from '../../services/api.js';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import PacmanLoader from '../../components/PacmanLoader/PacmanLoader.js';
import { stringToHash } from '../../utils/auth/passwordHash';
import { useAuth } from '../../auth/useAuth';

function ResetPass(){
    const navigate = useNavigate();
    const[senha, setSenha] = useState('');
    const{guid} = useParams();
    const[loadding, setLoadding] = useState(false);
    const { isAuthenticated } = useAuth();

    async function reset(){
        setLoadding(true);
        await api.post(`/recuperasenha/reset-pass?guid=` + guid + '&pass=' + stringToHash(senha) + `&tipo=QuestoesAqui`)
            .then((response) => {
                setLoadding(false);
                if(response.data.success){
                    toast.success('Login liberado com a nova senha!');
                    navigate('/login', {replace: true});
                }
                else{
                    toast.error('Usuário não encontrado!');
                    navigate('/', {replace: true});
                }
            }).catch(() => {
                setLoadding(false);
                toast.error('Usuário não encontrado!');
                return;
            });
    }

    if(isAuthenticated){
        navigate('/', {replace: true});
    }

    if(loadding){
        return(
            <PacmanLoader/>
        )
    }

    return (
        <div className="containerpage global-fullW">
            <div className='login'>
                <h2>
                    Nova senha
                </h2>
                <input type="password" name='pass' id='pass' value={senha} onChange={(e) => setSenha(e.target.value)} required={true}></input>
                <button onClick={reset}>Resetar a senha</button>
            </div>
        </div>
    )
}

export default ResetPass;
